<template >
    <div class="container bg-white py-5 px-5" v-if="school && lesson">
      <h4 class="font-weight-bold">Хичээлийн нэр: {{lesson.name}} <span v-if="lesson && lesson.classNos && lesson.classNos.length>0"> - {{lesson.classNos[0]}}</span></h4>
      <button type="button" class="btn btn-danger my-3" @click="_addProgram()">
        Хуваарь нэмэх
      </button>

      <!-- DataTales Example -->
      <div class="card mb-4" >
        <div class="card-header py-3">
          <h5 class="m-0 font-weight-bold text-primary">Хуваарь</h5>
        </div>
        <div class="card-body" v-if="pros!=null && pros.length>0">
          <div class="table-responsive">
            <table class="table" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Гарaг</th>
                  <th>Ээлж/цаг</th>
                  <th>Анги/Групп</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(p, index) in pros" v-bind:key="p.id">
                  <td>{{index+1}}</td>
                  <td>
                    {{_getDayName(p.day)}}
                  </td>
                  <td>
                    {{p.line}} ээлж, {{p.time}} цаг
                  </td>
                  <td>
                    <div v-if="p.programData">
                      <span v-if="p.departmentData">{{p.departmentData.name}}/</span>
                      {{p.programData.name}}
                    </div>
                    <div v-if="p.groupData">
                      {{p.groupData.name}}
                    </div>
                  </td>
                  <td>
                    <i class="fas fa-edit text-secondary myicon mr-4" @click="_editProgram(p)" style="cursor:pointer"></i>
                    <i class="fas fa-trash text-secondary myicon" @click="_deleteProgram(p)" style="cursor:pointer"></i>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
      </div>

      <div class="card-body p-0">

        <div class="table-responsive">
          <table class="table table-sm">
            <tr style="border:2px solid black;">
              <th >Ээлж</th>
              <th style="border-left:2px solid black;">Цаг</th>
              <th v-for="day in weekNumbers" style="border-left:1px solid black!important;">
                <span v-if="day==1">Даваа</span>
                <span v-if="day==2">Мягмар</span>
                <span v-if="day==3">Лхагва</span>
                <span v-if="day==4">Пүрэв</span>
                <span v-if="day==5">Баасан</span>  
              </th>
            </tr>
            <tbody v-for="line in lines" style="border:2px solid black;">
              <tr v-for="(time, index) in times">
                <td v-if="index==0" :rowspan="times.length" >{{line}} ээлж</td>
                <td style="border-left:2px solid black;">{{time}}-р цаг
                  <span class="font-weight-bold text-primary" v-if="line && time"><br/>{{isIn(line+'-'+time)}}</span>
                </td>
                <td v-for="day in weekNumbers" style="border-left:1px solid black!important;">
                  <div v-for="p in _getTimeObject(day,line,time)" class="text-primary" >
                    <div v-if="p.programData">
                      <span v-if="p.departmentData">{{p.departmentData.name}}/</span>
                      {{p.programData.name}}
                    </div>
                    <div v-if="p.groupData">
                      {{splitName(p.groupData.name)}}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

      <!-- Modal -->
      <div class="modal fade" id="proModal" tabindex="-1" role="dialog" aria-labelledby="proModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="proModalLabel">Та энэ хичээл орох өдөр ээлж цаг ангиа оруулна уу</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">
                  <div class="col form-group" v-if="lesson && lesson.isGroup!=null && lesson.isGroup!=undefined && lesson.isGroup==true">
                    <label for="exampleFormControlSelect1">Групп :</label>

                    <select class="form-control"  v-model='pro.group'>
                      <option v-for="group in lesson.lessonGroups" v-bind:value="group.group">
                        {{group.groupName}}
                      </option>
                    </select>
                  </div>
                  <div v-else class="col form-group">
                    <label for="exampleFormControlSelect1">Анги :</label>

                    <select class="form-control"  v-model='pro.program'>
                      <option v-for="group in lesson.groups" v-bind:value="group.program">
                        {{group.departmentName}} - {{group.programName}}
                      </option>
                    </select>
                  </div>
                  
                  
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12 form-group">
                    <label for="exampleFormControlSelect1">Гарaг :</label>

                    <select class="form-control"  v-model='pro.day'>
                      <option v-for="day in weekNumbers" v-bind:value="day">
                        <span v-if="day==1">Даваа</span>
                        <span v-if="day==2">Мягмар</span>
                        <span v-if="day==3">Лхагва</span>
                        <span v-if="day==4">Пүрэв</span>
                        <span v-if="day==5">Баасан</span>

                      </option>
                    </select>
                  </div>
                  <div class="col-md-6 col-sm-12 form-group">
                    <label for="exampleFormControlSelect1">Ээлж :</label>

                    <select class="form-control"  v-model='pro.line'>
                      <option v-for="line in lines" v-bind:value="line">
                        {{line}} -р ээлж
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6 col-sm-12 form-group" v-if="pro && pro.line">
                    <label for="exampleFormControlSelect1">Цаг :</label>

                    <select class="form-control"  v-model='pro.time'>
                      <option v-for="time in times" v-bind:value="time">
                        {{time}} -р цаг
                      </option>
                    </select>
                  </div>
                  
                </div>
    

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="_saveTopic" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment';
import timetable from '../shared/timetable.js';

export default {
    name: "ILessonSchedule",
    data() {
        return {
          school:null,
          lesson:null,
          lines:[1, 2],
          times:[1, 2, 3, 4, 5, 6, 7],
          weekNumbers:[1,2,3,4,5],
          pro:{
            program:null,
            topic:'class',
            type:null,
            date:new Date(),
            line:null,
            time:null
          },
          pros:[],
          topics:[],
          loading:false
            
        };
    },
    mixins: [timetable],
    methods: {
      _deleteProgram(schedule){
        var yes = confirm("Та xуваарь устгаxыг xүсэж байна уу?");
        if(yes){
          schedule.ref.delete();
        }
      },
      _getDayName(dayNumber){

        if(dayNumber==1) return 'Даваа';
        else if (dayNumber==2) return 'Мягмар';
        else if (dayNumber==3) return 'Лxагва';
        else if (dayNumber==4) return 'Пүрэв';
        else if (dayNumber==5) return 'Баасан';
        else if (dayNumber==6) return 'Бямба';
        else if (dayNumber==7) return 'Ням';
        return 'N/A'
      },
      _getQA(){

          this._getTimeTables();
          

          fb.db.doc("schools/"+this.schoolId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.school=department;
              doc.ref.collection("lessons").doc(this.lessonId).get().then(ldoc=>{
                if(ldoc && ldoc.exists){
                  let item=ldoc.data();
                  item.id=ldoc.data();
                  this.lesson=item;

                  if(this.weekday && this.line && this.time){
                    this.loading=true;
                    
                    setTimeout(()=>{ 
                      this.loading=false;
                      
                      this._addProgram(this.weekday ,this.line ,this.time);
                    }, 1500);
                    
                  }

                  ldoc.ref.collection("topics").orderBy("createdAt").get().then(tdocs=>{
                    this.topics=[];
                    tdocs.forEach(value=>{
                    
                      if(value.exists){
                        let object=value.data();
                        object.id=value.id;
                        object.ref=value.ref;
                        this.topics.push(object);
                      }
                    })
                  });

                  ldoc.ref.collection("lessonschedule").orderBy("createdAt", "desc").onSnapshot(tdocs=>{
                    this.pros=[];
                    tdocs.forEach(value=>{
                      if(value.exists){
                        let object=value.data();
                        object.id=value.id;
                        object.ref=value.ref;
                        object.programData=null;
                        object.departmentData=null;
                        object.groupData=null;
                        if(object.program)
                        {
                          object.program.get().then(pdoc=>{
                            if(pdoc.exists){
                              object.programData=pdoc.data();
                              if(pdoc.ref.parent.parent){
                                pdoc.ref.parent.parent.get().then(ddoc=>{
                                  object.departmentData=ddoc.data();
                                });
                              }
                            }
                          });
                        }
                        if(object.group)
                        {
                          object.group.get().then(pdoc=>{
                            if(pdoc.exists){
                              object.groupData=pdoc.data();
                         
                            }
                          });
                        }
  
                        this.pros.push(object);
                      }
                    })
                  });
                }
              })
          });


      },

      _addProgram(wday, wline, wtime){
        console.log(wday);
          this.pro={
              program:null,
              group:null,
              day:wday,
              line:wline,
              time:wtime
            };
          $('#proModal').modal('toggle');
      },
      _editProgram(pro){

          this.pro= Object.assign({}, pro);
          $('#proModal').modal('toggle');
      },
      async _saveTopic(){
        if(this.pro && (this.pro.program || this.pro.group) && this.pro.day && this.pro.line && this.pro.time){
          var docRef;
          if(this.pro && this.pro.id && this.pro.id!='' && this.pro.id!='new')
            docRef=fb.db.collection("schools/"+this.schoolId+'/lessons/'+this.lessonId+'/lessonschedule').doc(this.pro.id);
          else{
            docRef=fb.db.collection("schools/"+this.schoolId+'/lessons/'+this.lessonId+'/lessonschedule').doc();
            this.pro.createdAt=new Date();
          }
          if(this.currentUser && this.currentUser.uid)
            this.pro.user=fb.db.collection("users").doc(this.currentUser.uid);
          this.pro.school=fb.db.doc("schools/"+this.schoolId);
          this.pro.lesson=fb.db.doc("schools/"+this.schoolId+'/lessons/'+this.lessonId);
          this.pro.teacher=this.lesson.teacher?this.lesson.teacher:null;
          this.pro.isGroup=this.lesson.isGroup!=null && this.lesson.isGroup!=undefined?this.lesson.isGroup:false;
          this.pro.classNos=this.lesson.classNos?this.lesson.classNos:null;

          await docRef.set(this.pro, {merge:true});
          this.pro={
              program:null,
              group:null,
              day:null,
              line:null,
              time:null
          };
    
        }
        else
          alert("Та анги болон хичээл орох өдөр ээлж цагаа сонгоно уу.");
      },
      _getTimeObject(day,line,time){
        var results=[];
        if(day && line && time){
          if(this.pros && this.pros.length>0){
            for(const schedule of this.pros){
              if(schedule && schedule.day==day && schedule.line==line && schedule.time==time){
                results.push(schedule);
              }
            }
          }
        }
        return results;
      },
      splitName(name){
        if(name && name.includes("/")){
          var n = name.indexOf("/");
          return name.substring(n, name.length);
        }
        return name;
      }
   

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
      schoolId:{
        required:true
      },
      lessonId: { 
          required: true,
      },
      line:{
        required:false
      },
      time:{
        required:false
      },
      weekday:{
        required:false
      }
    },
    created() {

        if(this.schoolId!=null && this.schoolId!='' && this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatTimestamp(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm')
        }
        return '-'
      },
    
      formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val;
          return moment(date).format('MM/DD/YYYY HH:mm');
        }
        return '-'
      },
    
    }
  
};
</script>

